export default __webpack_public_path__ + "static/media/2019.4eacd298.png";